//mui
import {createTheme} from '@mui/material';
//components
import {MuiInputBase, MuiInputLabel, MuiOutlinedInput} from '@/utils/theme/components/Input';
import {MuiRadio} from '@/utils/theme/components/Radio';
import {MuiCheckbox} from '@/utils/theme/components/Checkbox';
import {MuiButton} from '@/utils/theme/components/Button';
import {MuiSelect} from '@/utils/theme/components/Select';
import {MuiSwitch} from '@/utils/theme/components/Switch';
import {MuiCircularProgress} from '@/utils/theme/components/Loader';
import {MuiPaper} from '@/utils/theme/components/Paper';
import {MuiFormHelperText} from '@/utils/theme/components/FormHelperText';
import {MuiLinearProgress} from '@/utils/theme/components/ProgressBar';
import {MuiTabs} from '@/utils/theme/components/Tabs';
import {MuiBadge} from '@/utils/theme/components/Badge';
import {MuiTypography} from '@/utils/theme/components/Typography';
import {MuiFormControlLabel} from '@/utils/theme/components/FormControlLabel';
import {MuiFormControl} from '@/utils/theme/components/MuiFormControl';
import {MuiStepConnector} from '@/utils/theme/components/StepConnector';
import {MuiTable} from '@/utils/theme/components/Table';
import {MuiTableSortLabel} from '@/utils/theme/components/TableSortLabel';
import {MuiTooltip} from '@/utils/theme/components/Tooltip';

declare module '@mui/material/styles' {
	export interface Palette {
		white: string;
		neutral50: string;
		neutral100: string;
		neutral200: string;
		neutral300: string;
		neutral400: string;
		neutral500: string;
		neutral900: string;
		primary100: string;
		primary200: string;
		primary400: string;
		primary500: string;
		primary600: string;
		primary900: string;
		success100?: string;
		success200?: string;
		success400?: string;
		success500?: string;
		success600?: string;
		success900?: string;
		error100: string;
		error200: string;
		error400: string;
		error500: string;
		error600: string;
		warning100: string;
		warning200: string;
		warning400: string;
		warning500: string;
		warning600: string;
	}
	interface PaletteOptions {
		white: string;
		neutral50?: string;
		neutral100?: string;
		neutral200?: string;
		neutral300?: string;
		neutral400?: string;
		neutral500?: string;
		neutral900?: string;
		primary100?: string;
		primary200?: string;
		primary400?: string;
		primary500?: string;
		primary600?: string;
		primary900?: string;
		success100?: string;
		success200?: string;
		success400?: string;
		success500?: string;
		success600?: string;
		success900?: string;
		error100?: string;
		error200?: string;
		error400?: string;
		error500?: string;
		error600?: string;
		warning100?: string;
		warning200?: string;
		warning400?: string;
		warning500?: string;
		warning600?: string;
	}
}

declare module '@mui/material/Button' {
	interface ButtonPropsVariantOverrides {
		filled: true;
		outline: true;
	}
}

const theme = createTheme({
	palette: {
		white: '#fff',
		neutral50: '#fbfbfb',
		neutral100: '#f0f1f4',
		neutral200: '#c3c7d4',
		neutral300: '#8F98A9',
		neutral400: '#6b788f',
		neutral500: '#515B75',
		neutral900: '#0c1525',
		primary100: '#e6f8ff',
		primary200: '#b6eafe',
		primary400: '#52c9f8',
		primary500: '#26b5ed',
		primary600: '#128ebf',
		primary900: '#002736',
		success100: '#DBF9E8',
		success200: '#A6F6CA',
		success400: '#00DE7F',
		success500: '#01C860',
		success600: '#00BA41',
		success900: '#013310',
		error200: '#feb4b6',
		error100: '#fee6e8',
		error400: '#fe4a52',
		error500: '#fb0b24',
		error600: '#ca0008',
		warning100: '#fceddb',
		warning200: '#feddaf',
		warning400: '#f5aa3d',
		warning500: '#f19702',
		warning600: '#c27501',
	},
	breakpoints: {
		values: {
			xs: 0,
			sm: 375,
			md: 1200,
			lg: 1200,
			xl: 1920,
		},
	},
	typography: {
		fontFamily: 'Lato',
	},
	components: {
		MuiButton,
		MuiFormControl,
		MuiRadio,
		MuiCheckbox,
		MuiInputBase,
		MuiInputLabel,
		MuiOutlinedInput,
		MuiSelect,
		MuiPaper,
		MuiFormHelperText,
		MuiSwitch,
		MuiLinearProgress,
		MuiTabs,
		MuiBadge,
		MuiCircularProgress,
		MuiTypography,
		MuiFormControlLabel,
		MuiStepConnector,
		MuiTable,
		MuiTableSortLabel,
		MuiTooltip,
	},
});

export type ThemePaletteKeys = keyof typeof theme.palette;

export default theme;
